import { settings } from "survey-creator-core";

export default function Settings() {
  settings.themeEditor.exportFileName = "form_theme.json";
}
